// Run-history tab ids and the route-segment rule for `/runs/:tab?` (sc-114199).

/** Every run-history tab in display order. The id is the URL segment: `/runs/<id>`. */
export const RUN_TABS = ["succeeded", "failed", "processing", "scheduled", "enqueued"] as const;
export type RunTab = (typeof RUN_TABS)[number];

/** The tab a bare `/runs` renders, and the one an unknown segment redirects to. */
export const DEFAULT_RUN_TAB: RunTab = "succeeded";

/**
 * No segment → `DEFAULT_RUN_TAB`; a known id → itself; anything else → `null` (the page redirects).
 * Ids match exactly, so `Failed` is unknown.
 */
export function resolveRunTab(segment: string | undefined): RunTab | null {
  if (segment === undefined) return DEFAULT_RUN_TAB;
  return (RUN_TABS as readonly string[]).includes(segment) ? (segment as RunTab) : null;
}
